import Skeleton from '@/components/atom/Skeleton';

const IntegratedSearchResultSkeleton = () => {
  return (
    <div>
      <div className={'border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_24px_24px]'}>
        <Skeleton className={'mb-[8px] h-[18px] w-[100px]'} />
        <Skeleton className={'mb-[5px] h-[30px] w-[150px]'} />
        <Skeleton className={'mb-[8px] h-[30px] w-[230px]'} />
        <Skeleton className={'mb-[5px] h-[20px] w-[300px]'} />
        <Skeleton className={'mb-[5px] h-[20px] w-[200px]'} />
      </div>

      <div className={'border-0 border-b-[16px] border-b-gray-30 border-solid bg-gray-40'}>
        <div className={'mb-[1px] bg-white p-[28px_24px_24px] pb-[16px]'}>
          <Skeleton className={'mb-[16px] h-[18px] w-[70px]'} />
          <div className={'flex justify-between gap-[16px]'}>
            <div className={'flex flex-col gap-[2px]'}>
              <Skeleton className={'h-[18px] w-[70px]'} />
              <Skeleton className={'h-[24px] w-[140px]'} />
              <Skeleton className={'mb-[11px] h-[18px] w-[160px]'} />
              <div className={'flex gap-[8px]'}>
                <Skeleton className={'h-[20px] w-[60px]'} />
                <Skeleton className={'h-[20px] w-[35px]'} />
                <Skeleton className={'h-[20px] w-[45px]'} />
              </div>
            </div>
            <Skeleton className={'h-[120px] w-[120px]'} />
          </div>
        </div>
        <div className={'mb-[1px] bg-white p-[28px_24px_24px] pb-[16px]'}>
          <Skeleton className={'mb-[16px] h-[18px] w-[70px]'} />
          <div className={'flex justify-between gap-[16px]'}>
            <div className={'flex flex-col gap-[2px]'}>
              <Skeleton className={'h-[18px] w-[70px]'} />
              <Skeleton className={'h-[24px] w-[140px]'} />
              <Skeleton className={'mb-[11px] h-[18px] w-[160px]'} />
              <div className={'flex gap-[8px]'}>
                <Skeleton className={'h-[20px] w-[60px]'} />
                <Skeleton className={'h-[20px] w-[35px]'} />
                <Skeleton className={'h-[20px] w-[45px]'} />
              </div>
            </div>
            <Skeleton className={'h-[120px] w-[120px]'} />
          </div>
        </div>
        <div className={'bg-white p-[28px_24px_24px] pb-[16px]'}>
          <Skeleton className={'mb-[16px] h-[18px] w-[70px]'} />
          <div className={'flex justify-between gap-[16px]'}>
            <div className={'flex flex-col gap-[2px]'}>
              <Skeleton className={'h-[18px] w-[70px]'} />
              <Skeleton className={'h-[24px] w-[140px]'} />
              <Skeleton className={'mb-[11px] h-[18px] w-[160px]'} />
              <div className={'flex gap-[8px]'}>
                <Skeleton className={'h-[20px] w-[60px]'} />
                <Skeleton className={'h-[20px] w-[35px]'} />
                <Skeleton className={'h-[20px] w-[45px]'} />
              </div>
            </div>
            <Skeleton className={'h-[120px] w-[120px]'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegratedSearchResultSkeleton;
